module.exports = __webpack_public_path__ + "img/skootel.894c74a1.png";